import React, { useEffect, useMemo, useState } from 'react';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import S from './Widget.module.scss';
import WidgetHeaderControls from './WidgetHeaderControls';
import MapPreview from './MapPreview';

const WidgetPlan = ({
  vuesFavorites = [],
  onVueClick,
  headerContent = null,
  showHeader = true,
}) => {
  // Afficher une vue favorite ou une image placeholder
  const hasVue = vuesFavorites && vuesFavorites.length > 0;
  const [selectedVueIndex, setSelectedVueIndex] = useState('0');
  const vuesLength = vuesFavorites?.length || 0;

  useEffect(() => {
    if (!hasVue) {
      setSelectedVueIndex('0');
      return;
    }

    const currentIndex = Number(selectedVueIndex);
    if (currentIndex >= vuesLength) {
      setSelectedVueIndex('0');
    }
  }, [hasVue, vuesLength, selectedVueIndex]);

  const vueOptions = useMemo(() => {
    if (!hasVue || vuesLength < 2) {
      return [];
    }

    return vuesFavorites.map((vue, index) => ({
      value: String(index),
      label: vue.view_name || `${checkMot('plan')} ${index + 1}`,
    }));
  }, [hasVue, vuesFavorites, vuesLength]);

  const currentVue = hasVue
    ? vuesFavorites[Number(selectedVueIndex)] || vuesFavorites[0]
    : null;

  const resolveCenter = (vue) => {
    if (!vue) return null;
    if (Array.isArray(vue.center) && vue.center.length === 2) return vue.center;
    if (vue.lat && vue.lng) return [vue.lat, vue.lng];
    if (vue.latitude && vue.longitude) return [vue.latitude, vue.longitude];
    if (vue.center_lat && vue.center_lng)
      return [vue.center_lat, vue.center_lng];
    return null;
  };

  const mapCenter = resolveCenter(currentVue) || [48.8566, 2.3522];
  const mapZoom = currentVue?.zoom || 12;

  const resolvedHeader =
    headerContent ||
    (showHeader ? (
      <WidgetHeaderControls
        titleKey="plan"
        selectOptions={vueOptions}
        selectedValue={selectedVueIndex}
        onSelectChange={setSelectedVueIndex}
      />
    ) : null);

  return (
    <div className={[S.widget, S.widgetLarge].join(' ')}>
      {resolvedHeader}
      <div className={S.widgetContent}>
        {hasVue ? (
          <div className={S.planContainer}>
            <div className={S.planPreview}>
              <MapPreview
                center={mapCenter}
                zoom={mapZoom}
                className={S.leafletContainer}
                interactive={true}
              />
            </div>
          </div>
        ) : (
          <div className={S.emptyState}>
            <div className={S.mapPlaceholder}>
              <MapPreview
                center={[48.8566, 2.3522]}
                zoom={3}
                className={S.leafletContainer}
                interactive={true}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default WidgetPlan;
